export enum Flags {
    'NEW'= 'NEW',
    'USER' = 'USER',
    'DEPRECATED' = 'DEPRECATED'
}

export interface Image {
    id:string
    type?: Type // 'app ou so'
    flags?: Flags[]|null //array de flags, até o momento espero receber 'NW' para novas imagens e 'USER' para templates customizados
    minRequirements?: { // requerimentos mínimo de hardware para instalar o template
        disk?: number // quantidade de disco em GB
        vcpu?: number //quantidade de vcpu
        memory?: number //quantidade de memória em MB
    }
    template?: Template
    operationalSystem?: { //o sistema operacional da imagem, este objeto sempre virá preenchido
        name?: string // nome do sistema operacional, acho que as únicas opções são Windows Server e Ubuntu Server e CentOS
        shortName?:string //usar o campo icon da api
        version?: string // versão do SO, exemplos?: 16.04 LTS (para ubuntu), 2008 R2 (para windows), 6.5 (para o CentOS)
        arch?: number // deve retornar 32 ou 64
        price?:{
            unitPrice?: number //valor da licença, exemplo de formato?: 20.00, caso seja incluso retornar 0
            chargeType?: 'FLAT' | 'VCPU' //'FLAT ou VCPU'
        }
    }
    application?: { //retornar os campos abaixo como nulo, caso ele não seja uma imagem
        name?:string //retornar nome da aplicação ex?: Wordpress, Cassandra, Jenkins etc
        shortName?:string //usar o campo icon da api
        version?:string  //ex?: 1.31.1
        link?: string //link para acessar a imagem
        price?:{
            unitPrice?: number //'20.00 ou 0'
            chargeType?: string //'FLAT ou VCPU'
        }
    } | null
}

export enum Type {
    APP = 'app',
    SO = 'os'
}

export interface Template {
    id?:string
    name?: string
    description?: string
    creationDate?: string 
    image?:Image,
    actions?:{
        cancel?:boolean
    }
}
